import { LocalStorageService } from './../services/local-storage.service';
import { Router } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CheckoutService } from './checkout.service';
import { Injectable } from '@angular/core';
import { CheckoutState } from '../checkout/checkout.reducer';

@Injectable()
export class CheckoutGuard {
  constructor(
    private checkoutService: CheckoutService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    if (this.checkoutService.getCheckout()) {
      return Promise.resolve(true);
    }
    this.router.navigateByUrl('/checkout/select');
    return Promise.resolve(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/checkout.guard.ts